import { NewProviderDeal, UpdatedProviderDeal } from './provider-deal.types';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ProviderDealService {
	private dealsUri = 'api/providerDeals';
	private dealUrl = (dealId: number) => `${this.dealsUri}/${dealId}`;

	constructor(private http: HttpClient) { }

	addDeal(newDeal: NewProviderDeal): Promise<number> {
		return this.http.post<number>(this.dealsUri, newDeal).toPromise();
	}

	updateDeal(updatedDeal: UpdatedProviderDeal, dealId: number): Promise<void> {
		return this.http.put<void>(this.dealUrl(dealId), updatedDeal).toPromise();
	}

	deleteDeal(dealId: number): Promise<void> {
		return this.http.delete<void>(this.dealUrl(dealId)).toPromise();
	}
}
